import { NgModule } from '@angular/core';
import { RouterModule, Routes } from '@angular/router';
import { routingDashboardModuleType, routingModuleType } from '../shared/enums/module-types';

const routes: Routes = [
  { path: '', redirectTo: routingModuleType.dashboard + '/' + routingDashboardModuleType.analytics, pathMatch: 'full' },

  { path: routingModuleType.dashboard + '/' + routingDashboardModuleType.analytics, data: { breadcrumb: 'lbl_analytics_dashboard', icon: 'pi pi-home' }, loadChildren: () => import('./components/analytics/analytics.module').then(m => m.AnalyticsModule) },
  { path: routingModuleType.dashboard + '/' + routingDashboardModuleType.sales, data: { breadcrumb: 'lbl_sales_dashboard', icon: 'pi pi-home' }, loadChildren: () => import('./components/sales/sales.module').then(m => m.SalesModule) },
  { path: routingModuleType.dashboard + '/' + routingDashboardModuleType.saas, data: { breadcrumb: 'lbl_saas_dashboard', icon: 'pi pi-home' }, loadChildren: () => import('./components/saas/saas.module').then(m => m.SaasModule) },
];

@NgModule({
  imports: [RouterModule.forChild(routes)],
  exports: [RouterModule]
})
export class DashboardRoutingModule { }
